class K7GewaehrleistungslabelZoom extends HTMLElement {
  connectedCallback() {
    if (this.dataset.k7Init === 'true') return;
    this.dataset.k7Init = 'true';

    if (this.hasAttribute('data-k7-portal')) {
      window.__k7GewaehrleistungslabelZoomEl = this;
      if (!window.__k7GewaehrleistungslabelZoomBound) {
        window.__k7GewaehrleistungslabelZoomBound = true;
        document.addEventListener('click', (event) => {
          const root = window.__k7GewaehrleistungslabelZoomEl;
          if (!root) return;
          const trigger = event.target.closest('[data-k7-gewaehrleistungslabel-open]');
          if (!trigger) return;
          event.preventDefault();
          event.stopPropagation();
          root.open();
        }, true);
      }
    }
  }

  async open() {
    const image = this.querySelector('img');
    if (!image || this._opening) return;
    this._opening = true;

    try {
      const PhotoSwipe = (await import(this.dataset.photoswipeUrl)).default;
      const photoswipe = new PhotoSwipe({
        dataSource: [
          {
            element: image,
            src: image.currentSrc || image.src,
            msrc: image.currentSrc || image.src,
            width: parseInt(image.getAttribute('width'), 10) || 1785,
            height: parseInt(image.getAttribute('height'), 10) || 2526,
            alt: image.alt
          }
        ],
        index: 0,
        bgOpacity: 1,
        maxZoomLevel: 4,
        arrowPrev: false,
        arrowNext: false,
        counter: false,
        zoom: true,
        closeTitle: window.themeVariables?.strings?.closeGallery,
        zoomTitle: window.themeVariables?.strings?.zoomGallery,
        errorMsg: window.themeVariables?.strings?.errorGallery,
        closeSVG: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 56 56">
          <path d="M56 28C56 12.536 43.464 0 28 0S0 12.536 0 28s12.536 28 28 28 28-12.536 28-28Z" fill="#fff"/>
          <path d="M55.5 28C55.5 12.812 43.188.5 28 .5S.5 12.812.5 28 12.812 55.5 28 55.5 55.5 43.188 55.5 28Z" stroke="#252627" stroke-opacity=".12"/>
          <path d="m22.344 22.343 11.313 11.314m-11.313 0 11.313-11.313" stroke="#252627" stroke-width="2"/>
        </svg>`
      });
      photoswipe.on('destroy', () => {
        this._opening = false;
      });
      photoswipe.init();
    } catch (error) {
      this._opening = false;
    }
  }
}

if (!customElements.get('k7-gewaehrleistungslabel-zoom')) {
  customElements.define('k7-gewaehrleistungslabel-zoom', K7GewaehrleistungslabelZoom);
}
